import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import './Manage_User.css';
import Header from './Header.js';
import Sidebar from './Sidebar.js';
import Footer from './Footer.js';
import Pagination from './Pagination.js';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function Route_Mapping() {
    const token = localStorage.getItem("authToken") || null;
    const navigate = useNavigate();

    const [routeList, setRouteList] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [isLoading, setIsLoading] = useState(true);



    const fetchRoutes = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}get_routes`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            });
            const data = await response.json();
            if (data.status && Array.isArray(data.data)) {
                setRouteList(data.data);
            }
        } catch (err) {
            console.error("Error fetching routes:", err);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchRoutes();
    }, []);

    const filteredRoutes = routeList.filter(route =>
        route.route_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        route.branch_id.toLowerCase().includes(searchQuery.toLowerCase())
    );

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredRoutes.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(filteredRoutes.length / itemsPerPage);


    const handleDelete = async (id) => {
        // Show confirmation prompt
        const isConfirmed = window.confirm("Are you sure you want to delete this repair form?");

        if (!isConfirmed) {
            // If the user clicks "Cancel", exit the function without doing anything
            return;
        }

        try {
            const token = localStorage.getItem('authToken');
            const response = await fetch(`${API_BASE_URL}delete_route/${id}`, {
                method: 'POST',  // HTTP method
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            if (response.ok) {

                navigate('/route_mapping');
                window.location.reload();
                // Optionally, you can also update the UI after the deletion
                // For example, remove the deleted item from the list
            } else {
                alert("Failed to delete the logistic form.");
            }
        } catch (error) {
            console.error("Error deleting logistic form:", error);
            alert("There was an error while deleting the logistic form.");
        }
    };

    return (
        <div className="hold-transition sidebar-mini layout-fixed" style={{ fontSize: '12px' }}>
            <div className="wrapper">
                <Header />
                <Sidebar />
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h4 className="m-0" style={{ fontSize: '20px' }}>Route Mapping List</h4>
                                </div>
                                <div className="col-sm-6">
                                    <ol className="breadcrumb float-sm-right">
                                        <li className="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                                        <li className="breadcrumb-item active">Route Mapping</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">
                            <div className="card">
                                <div className="card-header">
                                    <span style={{ float: 'right' }}>
                                        <Link to="/add_route_mapping">
                                            <button type="button" className="btn btn-sm btn-success">Add New</button>
                                        </Link>
                                    </span>
                                </div>
                                <div className="card-body">
                                    {isLoading ? (
                                        <p>Loading...</p>
                                    ) : (
                                        <>
                                            <div className="row mb-2">
                                                <div className="col-md-6">
                                                    <input
                                                        type="text"
                                                        value={searchQuery}
                                                        onChange={(e) => setSearchQuery(e.target.value)}
                                                        className="form-control form-control-sm"
                                                        placeholder="Search by route or branch"
                                                    />
                                                </div>
                                                <div className="col-md-3">
                                                    <select
                                                        className="form-control form-control-sm"
                                                        value={itemsPerPage}
                                                        onChange={(e) => {
                                                            setItemsPerPage(Number(e.target.value));
                                                            setCurrentPage(1);
                                                        }}
                                                    >
                                                        <option value={10}>10</option>
                                                        <option value={25}>25</option>
                                                        <option value={50}>50</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="table-responsive">
                                                <table className="table table-hover text-nowrap">
                                                    <thead>
                                                        <tr>
                                                            <th>#</th>
                                                            <th>Route Name</th>
                                                            <th>Branches</th>
                                                            <th>Created On</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {currentItems.length > 0 ? (
                                                            currentItems.map((route, index) => (
                                                                <tr key={index}>
                                                                    <td>{index + 1 + (currentPage - 1) * itemsPerPage}</td>
                                                                    <td>{route.route_name}</td>
                                                                    <td>{route.branch_ids.join(", ")}</td>
                                                                    <td>
                                                                        {new Date(route.created_on).toLocaleString("en-IN", {
                                                                            timeZone: "Asia/Kolkata"
                                                                        })}
                                                                    </td>
                                                                    <td>
                                                                        <Link to={`/edit_route_mapping/${route.id}`}>
                                                                            <i className="fa fa-edit" style={{ marginRight: '10px', fontSize: '12px', color: 'green' }}></i>
                                                                        </Link>
                                                                        <i className="fa fa-trash" onClick={() => handleDelete(route.id)} style={{ marginRight: '10px', fontSize: '12px', color: 'green' }}></i>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="5">No routes found</td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>

                            <Pagination
                                currentPage={currentPage}
                                totalPages={totalPages}
                                handlePageChange={setCurrentPage}
                            />
                            <div className="mb-3">
                                Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, filteredRoutes.length)} of {filteredRoutes.length} entries
                            </div>
                        </div>
                    </section>
                </div>
                <Footer />
            </div>
        </div>
    );
}

export default Route_Mapping;
